export class MemoryClipboard {
    private static instance: MemoryClipboard;

    public static getInstance(): MemoryClipboard {
        if (!MemoryClipboard.instance) {
            MemoryClipboard.instance = new MemoryClipboard();
        }
        return MemoryClipboard.instance;
    }

    private clipboardData = {};

    public write(dataMap: any): void {
        this.clipboardData = dataMap;
    }

    public read(): any {
        return this.clipboardData;
    }
}
